import './PrivacyPolicy.css';
import ResizingIFrame from '../ResizingIFrame.js';

function ImpureChessPrivacyPolicy()
{
    return (
        <div className="PrivacyPolicy-Container">
            <ResizingIFrame id='ImpureChessPrivacyPolicy-Static-Container' iFrameTitle='Impure Chess Privacy Policy' htmlName='ImpureChessPrivacyPolicy/ImpureChessPrivacyPolicy.html' />
        </div>
    );
}

export default ImpureChessPrivacyPolicy;